/** @jsxImportSource @emotion/react */
import { UserBalance } from "../../../service/api-response/UserBalanceSuccessResponse";
import { SpinnerBlock } from "../../common/Spinner";
import { colors } from "../../../components/colors";
import { InfoBox } from "../../../components/Infobox";
import { StyledText } from "../../../assets/typography/typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { DetailsRow } from "../../../components/DetailsRow";
import { formatMoneyAmount } from "../../../util";
import { CardHeader } from "../../../components/CardHeader";
import { DepositSelector } from "../DepositSelector";
import { HistoricalBalancesSelector } from "./HistoricalBalancesSelector";
import { css } from "@emotion/react";
import { ButtonPrimary } from "../../../components/NewButtons";

interface OwnProps {
  balance: undefined | UserBalance;
  isLoadingBalance: boolean;
  isWithdrawingBalance: boolean;
  onWithdrawBalanceClick: (balance: UserBalance) => void;
}

const buttonsWrapperStyle = css`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const UserProfileBalancePartial = ({
  balance,
  isLoadingBalance,
  isWithdrawingBalance,
  onWithdrawBalanceClick,
}: OwnProps) => {
  const isWithdrawButtonDisabled = isWithdrawingBalance || isLoadingBalance;
  const hasBalanceAccount = !!balance;

  let subtitle = "";
  let showWithdraw = false; // TODO: Temporary solution for now showing withdrawn if multiplier is 1

  if (balance) {
    subtitle = `All balances are shown in ${balance.multiplier}x as user will see it in the app`;
    showWithdraw = (balance.multiplier || 3) > 1 || false;
  }

  return (
    <div className="card">
      <CardHeader title="Top up">
        <div css={buttonsWrapperStyle}>
          {balance && <HistoricalBalancesSelector balance={balance} />}
          {hasBalanceAccount && !showWithdraw && <DepositSelector />}
          {hasBalanceAccount && showWithdraw && (
            <ButtonPrimary
              type="button"
              height="fit-content"
              disabled={isWithdrawButtonDisabled}
              onClick={(e) => {
                e.preventDefault();
                balance
                  ? onWithdrawBalanceClick(balance)
                  : alert("Error: No balance object");
              }}
              className="w-fit"
            >
              Withdraw All
            </ButtonPrimary>
          )}
        </div>
      </CardHeader>
      <div className="card-body d-flex flex-column" style={{ gap: "16px" }}>
        <InfoBox backgroundColor={colors.ctaInactive} className="mb-2 p-5">
          <div className="d-flex flex-row text-left" style={{ gap: "16px" }}>
            <StyledText
              color={colors.textPrimary}
              className="bodyTextSemibold mb-0"
            >
              <FontAwesomeIcon icon={solid("info-circle")} />
            </StyledText>
            <StyledText
              color={colors.textPrimary}
              className="bodyTextSemibold mb-0"
            >
              {subtitle}
            </StyledText>
          </div>
        </InfoBox>
        {isLoadingBalance ? (
          <SpinnerBlock />
        ) : (
          <>
            {!hasBalanceAccount ? (
              <InfoBox
                backgroundColor={colors.ctaInactive}
                className="mb-2 p-5"
              >
                <div
                  className="d-flex flex-row text-left"
                  style={{ gap: "16px" }}
                >
                  <StyledText
                    color={colors.textPrimary}
                    className="bodyTextSemibold mb-0"
                  >
                    <FontAwesomeIcon icon={solid("info-circle")} />
                  </StyledText>
                  <StyledText
                    color={colors.textPrimary}
                    className="bodyTextSemibold mb-0"
                  >
                    User has no balance account
                  </StyledText>
                </div>
              </InfoBox>
            ) : (
              <>
                {balance && (
                  <>
                    <DetailsRow
                      leftText={"Top up Balance"}
                      rightText={formatMoneyAmount(
                        balance.balance,
                        balance.currency
                      )}
                    />
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
